import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  width: 19px;
  height: 19px;
`

export const ClockTimerIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" className={className}>
      <g clipPath="url(#clip0_655_31362)">
        <path d="M10.1027 1.1875C5.46549 1.1875 1.70536 4.90965 1.70536 9.5H-1.09375L2.53576 13.0928L2.60107 13.2222L6.37054 9.5H3.57143C3.57143 5.92562 6.49183 3.03472 10.1027 3.03472C13.7135 3.03472 16.6339 5.92562 16.6339 9.5C16.6339 13.0744 13.7135 15.9653 10.1027 15.9653C8.30192 15.9653 6.66911 15.2356 5.49348 14.0626L4.16857 15.3742C5.68942 16.8797 7.77942 17.8125 10.1027 17.8125C14.7399 17.8125 18.5 14.0903 18.5 9.5C18.5 4.90965 14.7399 1.1875 10.1027 1.1875ZM9.16964 5.80556V10.4236L13.135 12.7511L13.8535 11.5689L10.5692 9.63854V5.80556H9.16964Z" />
      </g>
      <defs>
        <clipPath id="clip0_655_31362">
          <rect width="19" height="19" fill="white" transform="translate(-0.5)" />
        </clipPath>
      </defs>
    </Svg>
  )
}
